/**
 * A utility method that grabs the desired fields from the URL parameters and
 * returns an object with the available fields.
 * @param field URL Parameters to extract
 * @returns Object containing found parameters
 */
function extractFieldsFromURLParams(fields: string[]) {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  const payload: Record<string, string> = {};
  fields.forEach((parameter) => {
    const value = searchParams.get(parameter);
    if (value) payload[parameter] = value;
  });
  return payload;
}

/**
 * Get the email and name fields from url parameters.
 */
export function getEmailAndNameFromURLParams() {
  return extractFieldsFromURLParams(["email", "name"]);
}

export default extractFieldsFromURLParams;
